import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from '@core';

@Component({
  selector: 'app-user-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, MatMenuModule, MatDividerModule],
  template: `
    <button
      mat-icon-button
      [matMenuTriggerFor]="userMenu"
      aria-label="User menu"
      data-testid="main-user-menu-trigger"
    >
      <mat-icon>account_circle</mat-icon>
    </button>
    <mat-menu #userMenu="matMenu">
      <button mat-menu-item (click)="navigateToProfile()" data-testid="main-user-menu-profile">
        <mat-icon>person</mat-icon>
        <span>Profile</span>
      </button>
      <button mat-menu-item (click)="navigateToPrivacy()" data-testid="main-user-menu-privacy">
        <mat-icon>shield</mat-icon>
        <span>Privacy &amp; Data</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()" data-testid="main-user-menu-logout">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  `,
})
export class UserMenuComponent {
  private auth = inject(AuthService);
  private router = inject(Router);

  navigateToProfile() {
    this.router.navigateByUrl('/profile');
  }

  navigateToPrivacy() {
    this.router.navigateByUrl('/profile/privacy');
  }

  logout() {
    const session = this.auth.getSession();
    this.auth.logout(session).subscribe({
      next: () => this.router.navigateByUrl('/auth/login'),
      error: () => this.router.navigateByUrl('/auth/login'),
    });
  }
}
